// Los cofres: inventario de recompensas con una llave que se gana estudiando.
//
// No hay `ganaCofre`: los cofres los concede el backend desde su fuente —la victoria del
// Jefe, un punto del Templo, un hito del Cielo—. Una función de cliente que concediera
// cofres sería un endpoint que regala cofres.
import { api } from "./client";

export const getCofres = async () => (await api.get("/cofres")).data;
export const empiezaCofre = async (cofreId) =>
  (await api.post("/cofres/empieza", { cofre_id: cofreId })).data;
// Los puntos del Templo. La lista la tiene el SERVIDOR —coordenadas, rareza y si ya se
// reclamó—, así que el Templo no lleva coordenadas de cofre escritas a mano y no se pueden
// inventar puntos desde la consola del navegador.
export const getPuntosCofres = async () => (await api.get("/cofres/puntos")).data;
export const reclamaPunto = async (puntoId) =>
  (await api.post("/cofres/reclama", { punto_id: puntoId })).data;

export const abreCofre = async (cofreId) =>
  (await api.post("/cofres/abre", { cofre_id: cofreId })).data;
